import { apiCall } from "./ApiCall";
import EncryptionUtils from "./encryptionUtils";
export const fetchPermissions = async () => {
  try {
    const roleId = EncryptionUtils.get("roleId");
    if (!roleId) {
      throw new Error("No role ID found");
    }
    const permissions = await apiCall("get", `/api/permissions/${roleId}`);
    if (!permissions) return null;
    EncryptionUtils.set("permissions", permissions);
    return permissions;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    return null;
  }
}; 